<drawer
  [title]="title"
  [showHeaderButtons]="true"
  [hideDelete]="true"
  [hideCancel]="false"
  [hideSave]="false"
  [isClosed]="false"
  (saveEvent)="addNewCertificate()"
  (cancelEvent)="cancel()"
  (closeEvent)="cancel()">
    <div class="drawer-content drawer-direct-content">
      <form class="form-validation">  
        <div class="row mt-4 fields-group">
          <div class="col-md-8 col-12">
            <label class="input-label field-required">{{
              'cert.name' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="name"
              [(ngModel)]="printDocument.name"
              placeholder="{{ 'Type a certicate name' | translate }}"
              #name="ngModel"
              [rangeLength]="[2, 256]"
              minlength="2"
              maxlength="256"
              required
              autofocus
              (input)="nameChanged($event.target.value)"
            />
            <p
              class="validation-error"
              *ngIf="name.errors?.required && (name?.dirty && name?.touched)">
              {{ 'form.validate.required' | translate }}
            </p>
            <p
              class="validation-error"
              *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p
              class="validation-error"
              *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 256!
            </p>
          </div>
          <div class="col-12 col-md-4">
              <label class="input-label field-required">{{
                'cert.shortName' | translate
              }}</label>
              <input
                class="form-control"
                type="text"
                name="shortName"
                [(ngModel)]="printDocument.shortName"
                placeholder="{{'Type a certicate short name' | translate}}"
                #shortName="ngModel"
                [rangeLength]="[2, 20]"
                minlength="2"
                maxlength="20"
                required
                autofocus
              />
              <p
                class="validation-error"
                *ngIf="shortName.errors?.required && (shortName?.dirty && shortName?.touched)">
                {{ 'form.validate.required' | translate }}
              </p>
              <p
                class="validation-error"
                *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && shortName?.touched)">
                {{ 'form.validate.minLenght' | translate }} 2!
              </p>
              <p
                class="validation-error"
                *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && shortName?.touched)">
                {{ 'form.validate.maxLenght' | translate }} 20!
              </p>
            </div>
        </div>
        </form>
    </div>
</drawer>